var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('ns-header-top'),_c('ns-header-mid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }